/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const utteranceTableCommandBarMessages = defineMessages({
    intents: {
        id: 'utterances.utteranceTableCommandBar.intents',
        defaultMessage: 'Intents'
    },
    intentDetailedScores: {
        id: 'utterances.utteranceTableCommandBar.intentDetailedScores',
        defaultMessage: 'Show detailed intent scores'
    },
    entities: {
        id: 'utterances.utteranceTableCommandBar.entities',
        defaultMessage: 'Entities'
    },
    entityPredictions: {
        id: 'utterances.utteranceTableCommandBar.entityPredictions',
        defaultMessage: 'Show entity predictions'
    },
    entityNames: {
        id: 'utterances.utteranceTableCommandBar.entityNames',
        defaultMessage: 'Show entity names'
    },
    subentities: {
        id: 'utterances.utteranceTableCommandBar.subentities',
        defaultMessage: 'Show subentities'
    },
    prebuiltRegexEntities: {
        id: 'utterances.utteranceTableCommandBar.prebuiltRegexEntities',
        defaultMessage: 'Show prebuilt and regex entities'
    },
    confirmEntityPredictions: {
        id: 'utterances.utteranceTableCommandBar.confirmEntityPredictions',
        defaultMessage: 'Confirm entities'
    },
    confirmEntityPredictionsAll: {
        id: 'utterances.utteranceTableCommandBar.confirmEntityPredictionsAll',
        defaultMessage: 'Confirm all entities'
    },
    moveToIntent: {
        id: 'utterances.utteranceTableCommandBar.moveToIntent',
        defaultMessage: 'Move to'
    },
    delete: {
        id: 'utterances.utteranceTableCommandBar.delete',
        defaultMessage: 'Delete'
    },
    search: {
        id: 'utterances.utteranceTableCommandBar.search',
        defaultMessage: 'Search for utterance(s)'
    },
    viewOptions: {
        id: 'utterances.utteranceTableCommandBar.viewOptions',
        defaultMessage: 'View options'
    },
    filterAriaLabel: {
        id: 'utterances.utteranceTableCommandBar.filterAriaLabel',
        defaultMessage: 'Toggle filters pane'
    },
    entityPaletteBtnAriaLabel: {
        id: 'utterances.utteranceTableCommandBar.entityPaletteBtnAriaLabel',
        defaultMessage: 'Toggle entity palette'
    },
    editUtterance: {
        id: 'utterances.utteranceTableCommandBar.editUtterance',
        defaultMessage: 'Edit utterance'
    },
    addToPatterns: {
        id: 'utterances.utteranceTableCommandBar.addToPatterns',
        defaultMessage: 'Add to patterns'
    },
    filter: {
        id: 'utterances.utteranceTableCommandBar.filter',
        defaultMessage: 'Toggle filters blade'
    },
    entityPalette: {
        id: 'utterances.utteranceTableCommandBar.entityPalette',
        defaultMessage: 'Toggle entity palette'
    }
});
